import React from "react";
import "./Css/Coffee.css";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Mug from "./Assets/Coffeemug.jpg";

const Coffee = () => {
  const coffeePage = () => {
    return (
      <div>
        <section className="coffee">
          <div className="coffeeCard">
            <div className="headingDiv">
              <h1 className="heading">Buy me a coffee</h1>
            </div>
            <div className="imgDiv">
              <a href="https://www.freepik.com/vectors/logo">
                <img src={Mug} alt="Coffee Mug" className="mugIcon" />
              </a>
            </div>
            <div className="descDiv">
              <p className="cardDesc">
                These api is completely free.No api key required or not any
                request limit.I wanted to build some project with my newly found
                knowledge of NodeJs.So I came across the github profile of @
                <a href="https://github.com/AyushSaini00">Ayush Saini</a> and
                see these api.So I think I should build these with some new and
                extra features.So I use the most powerful tool for
                developers(Google) and gathered all the ben10 aliens information
                and build this cool api.If you like it use it in your projects
                and tag me.Or you can buy me coffee it will help me as student
                to learn more and build more stuff.
              </p>
              <h3 className="thanku">Thank You 😀</h3>
            </div>
            <div className="buttonDiv">
              <a
                href="https://www.buymeacoffee.com/saurabhsonde"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                  alt="Buy Me A Coffee"
                />
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <Navigation />
      {coffeePage()}
      <Footer />
    </div>
  );
};

export default Coffee;
